import React from "react";

export default function StarIcon(props: React.ComponentProps<"svg">) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            {...props}
        >
            <g id="star" transform="translate(0.37 -0.3)">
                <rect
                    id="Rectangle-path_1_"
                    width="96"
                    height="96"
                    transform="translate(-0.37 0.3)"
                    fill="currentColor"
                />
                <path
                    id="Shape_1_"
                    d="M47.63,65l14.6-3.7,6.1,18.8Zm33.6-24.3H55.53l-7.9-24.2-7.9,24.2H14.03l20.8,15-7.9,24.2,20.8-15,12.8-9.2,20.7-15Z"
                    fill="#fff"
                />
            </g>
        </svg>
    );
}
